<style lang="less" scoped>
    @import url("~@/runtime-components/assets/common.css");

    .map {
        position: absolute;
        height: 100%;
        width: 100%;
        z-index: 0;
    }
</style>
<template>
    <div class="container">
        <div class="map" ref="map">
        </div>
    </div>
</template>

<script>
    export default {
        name: '',
        props: {
            isEditing: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {

            }
        },
        methods: {
            initMap() {
                const dom = this.$refs.map;
                const map = new BMapGL.Map(dom); // 创建Map实例
                map.centerAndZoom(new BMapGL.Point(118.5, 27.5), 4.5); // 初始化地图,设置中心点坐标和地图级别
                map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
                map.setMapType(BMAP_EARTH_MAP);
                if (!this.isEditing) {

                }
            }
        },
        mounted() {
            setTimeout(() => {
                this.initMap();
            }, 3000);

        },
        beforeDestroy() {

        }
    }
</script>